import React from 'react';
import './style.scss';
import language from '@language';

interface LayoutProps {
  title?: string;
  subtitle?: string;
  country?: string;
  manual?: string;
  children?: React.ReactNode;
}

export default ({ title, subtitle, country, manual, children }: LayoutProps) => {
  return (
    <div>
      <header>
        <div className="section-width">
          <div className="logo">
            <a href="https://booking.com" />
          </div>
          <div className="flag">{country && <img src={`/static/${country}.png`} />}</div>

          <div className="manual">{manual && <a rel="noopener noreferrer" target="_blank" href={manual} > {language.download_manual} </a>}</div>
        </div>
      </header>
      <section>
        <div className="section-width">
          <h1 className={(title) ? 'page-title' : ''}>{title}</h1>

          <div className="page-description">
            <p>{subtitle}</p>
          </div>
          <div className="content">{children}</div>
        </div>
        <footer>
          <div className="section-width">
            <p>Copyright © 1996–2021 Booking.com™. Todos los derechos reservados.</p>
          </div>
        </footer>
      </section>
    </div>
  );
}

